export default {

    RadioButtonSvg: function() {

        return `<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n" +
                        "        <defs>\n" +
                        "            <clipPath id=\"clip-Radio_Button_Checked\">\n" +
                        "                <rect width=\"24\" height=\"24\"/>\n" +
                        "            </clipPath>\n" +
                        "        </defs>\n" +
                        "        <g id=\"Radio_Button_Checked\" clip-path=\"url(#clip-Radio_Button_Checked)\">\n" +
                        "            <rect width=\"24\" height=\"24\" fill=\"rgba(81,91,96,0)\"/>\n" +
                        "            <g id=\"Group_13314\" data-name=\"Group 13314\">\n" +
                        "                <path id=\"Path_47\" data-name=\"Path 47\" d=\"M0,0H24V24H0Z\"  opacity=\"0\"/>\n" +
                        "                <path id=\"Path_48\" class="svg-primary-color" data-name=\"Path 48\" d=\"M12,7a5,5,0,1,0,5,5A5,5,0,0,0,12,7Zm0-5A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z\"  '  />\n" +
                        "            </g>\n" +
                        "        </g>\n" +
                        "    </svg>`
    },

    RadioButtonUncheckedSvg: function() {
        return `<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n" +
            "       <defs> \n" +
            "    <clipPath id=\"clip-Radio_Button_Unchecked\">\n" +
            "        <rect width=\"24\" height=\"24\"/>\n" +
            "    </clipPath>\n" +
            "</defs>\n" +
            "<g id=\"Radio_Button_Unchecked\" clip-path=\"url(#clip-Radio_Button_Unchecked)\">\n" +
            "    <rect width=\"24\" height=\"24\" fill=\"rgba(81,91,96,0)\"/>\n" +
            "    <g id=\"Group_13315\" data-name=\"Group 13315\">\n" +
            "        <path id=\"Path_49\" data-name=\"Path 49\" d=\"M0,0H24V24H0Z\" fill=\"#515b60\" stroke=\"rgba(0,0,0,0)\" stroke-width=\"1\" opacity=\"0\"/> \n" +
            "        <path id=\"Path_50\" data-name=\"Path 50\" d=\"M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z\" fill=\"#7b8387\" stroke=\"rgba(0,0,0,0)\" stroke-width=\"1\"/> \n" +
            "    </g>\n" +
            "</g>\n" +
            " </svg>`

    }
};



// WEBPACK FOOTER //
// ./src/common/plugins/svg/RadioButtonPlugin.js